import * as constants from "./../constants";

export default {
  title: "Pantry",
  language: "EN",
  navigation: {
    [constants.ROUTE_HOME]: "Home",
    [constants.ROUTE_LOGIN]: "Login",
    [constants.ROUTE_LOGOUT]: "@:user.logoutNotice.logoutButton",
    [constants.ROUTE_REGISTER]: "Sign up",
    [constants.ROUTE_CATEGORIES]: "Categories",
    [constants.ROUTE_CATEGORY_DETAIL]: "Category",
    [constants.ROUTE_CATEGORY_EDIT]: "Edit Category",
    [constants.ROUTE_NEW_CATEGORY]: "New Category",
    [constants.ROUTE_FOOD]: "Food",
    [constants.ROUTE_FOOD_EDIT]: "Edit Food",
    [constants.ROUTE_NEW_FOOD]: "New Food"
  },
  buttons: {
    back: "Back",
    cancel: "Cancel",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    save: "Save"
  },
  home: {
    welcome: "Welcome to your Pantry!",
    about:
      "Pantry is online tool for keeping track of food in your Pantry. Next time when you are standing in front of shelf full of jams in the store and trying to figure out how many of these you have at home, you will find anser in your pocket.",
    loginPrompt:
      "You will need an account where we will store state of food in your Pantry.<br>Login with existing one or create one for youself using the buttons below."
  },
  categories: {
    edit: "Edit Category <strong>{0}</strong>",
    name: "Name",
    recent: "Recent Categories",
    deleteConfirm:
      "Really delete category {0}?\nIt will be unassigned from all food having this category."
  },
  food: {
    edit: "Edit Food <strong>{0}</strong>",
    recent: "Recent Food",
    deleteConfirm: "Are you sure to delete {0}?"
  },
  user: {
    login: "Login",
    register: "Register",
    logoutNotice: {
      header: "Your login will expire soon",
      text:
        "You will be logged out automatically in <strong>{0}</strong>.<br>To stay logged, click the button below.",
      logoutButton: "Logout",
      stayButton: "Stay logged"
    }
  },
  forms: {
    amount: {
      label: "Amount",
      placeholder: "e.g. 5",
      helper: ""
    },
    categories: {
      label: "Categories",
      placeholder: "No category selected",
      helper:
        "You can assign categories to this item by selecting some of them from the right panel"
    },
    color: {
      label: "Color",
      placeholder: "e.g. e9521e",
      helper: "Insert RGB hexadecimal code"
    },
    email: {
      label: "Email",
      placeholder: "p@nt.ry",
      helper: "Your user account identiier at Pantry is your email address"
    },
    name: {
      label: "Name",
      placeholder: "Enter name",
      helper: ""
    },
    notes: {
      label: "Notes",
      placeholder: "e.g. We are missing 5 of these!!!",
      helper:
        "Any comments you need to know or remind to yourself about this item"
    },
    pantryId: {
      label: "Pantry ID (optional)",
      placeholder: "Unique ID of other user's pantry",
      helper:
        "If you want to share the same Pantry with your friend or family member, paste their unique Pantry ID here. Otherwise fresh new Pantry will be created for you."
    },
    password: {
      label: "Password",
      placeholder: "",
      helper:
        "Password must contain at least one capital letter, one lowercased letter and one number. Minimum length is 8 characters."
    }
  },
  search: {
    placeholder: "strawberry jam",
    button: "Search",
    noResultsFood: "None of your food items are matching the search criteria",
    noResultsCategories: "No category matching the name {0} was found"
  },
  sort: {
    order: "Sort order",
    name: {
      asc: "Sort by name ascending",
      desc: "Sort by name descending"
    },
    updated: {
      asc: "Show last updated last",
      desc: "Show last updated first"
    }
  }
};
